import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { API_LIMIT, MODULE_ID_MAP, Notifications, START_PAGE, isModuleExist } from "../../utils/Constant";
import { deleteUserGroupApi, getAllNotificationSetupApi } from "./Api";
import NotificationSetupForm from "./NotificationSetupForm";
import editPencil from "../../assets/images/edit-icon.png";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { toast } from "react-toastify";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";


export class NotificationSetup extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.NotificationsSend);
    this.state = {
      access: AccesData,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''
    };
  }

  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllNotificationSetupApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllNotificationSetupApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state?.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {

    deleteUserGroupApi(id, this, this.openCloseDeleteModal)
  }
  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;

    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete this ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.firstName}'`}
          show={this.state.show}
          url={+`/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllCampaignApi(this) }}
        />
        {
          //   true &&
          showEdit &&
          <NotificationSetupForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Notification Setup"
          isSearch={false}
          breadcrumb={[["Notifications", ""], ["Notification Setup", ""]]}
          placeholder={"Search setup"}
          onChangeMethod={this.onChangeMethod}
          clearSearch={() => this.clearSearch()}
          primaryBtn={access.createAccess ? "Add Notification Setup" : ''}
          handlePrimaryBtn={() => {

            this.setState({ showEdit: true })
          }}
          ctx={this}
        />
        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">

          <CustomTable
          ctx={this}
            data={listData?.list || []}
            columns={[

              {
                width: 200,
                title: "User Name",
                dataIndex: "userName",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.user?.firstName || "Na";
                },
              },
              {
                width: access.verificationAccess ? 100 : 0,
                title: "Verified",
                dataIndex: "isVerified",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                 const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                },
              },
              {
                width: 250,
                title: "Premium Plan",
                dataIndex: "premiumPlan",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.premiumPlan?.name || "Na";
                },
              },
              {
                width: 220,
                title: "Notification Templete ",
                dataIndex: "notificationTempleteId",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.notificationTemplete?.title || "Na";
                },
              },
              {
                width: 320,
                title: "Scheduled Date/Time ",
                dataIndex: "dateTime",
                className: "time",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    const date = new Date(rowData?.dateTime);
                    return date.toLocaleString('en-US', {
                      month: 'long', // Full month name
                      day: 'numeric', // Day of the month
                      year: 'numeric', // Full year
                      hour: 'numeric', // Hour
                      minute: 'numeric', // Minute
                      hour12: true, // Use 12-hour format
                    });
                  }
              },
              {
                width: 100,
                title: "Triggered",
                dataIndex: "isTriggered",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.isTriggered ? 'Yes' : 'No';
                },
              },
              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.updatedBy?.name || 'Na';
                },
              },

              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.createdBy?.name || 'Na';
                },
              },

              {
                width: 20,
                title: "Action",
                dataIndex: "",
                className: "",
                fixed: "right",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      // <div className="d-flex justify-content-end">
                      //   {access.updateAccess && !rowData.isTriggered && <Image src={editIcon} className="edit-icon" onClick={() => {
                      //     const rowDateTime = new Date(rowData?.dateTime);
                      //     const currentDate = new Date();

                      //     if (rowDateTime < currentDate) {
                      //       toast.error("Notification already sent.");
                      //     } else {
                      //       this.showEditModal(rowData);
                      //     }
                      //   }} />}
                      //   {access.deleteAccess && <Image src={deleteIcon} className="edit-icon"
                      //     onClick={() => {
                      //       const rowDateTime = new Date(rowData?.dateTime);
                      //       const currentDate = new Date();

                      //       if (rowDateTime < currentDate) {
                      //         toast.error("Notification already sent.");
                      //       } else {
                      //         this.openCloseDeleteModal(rowData);
                      //       }
                      //     }}
                      //   />}
                      // </div>
                      <OptionsDropdown
                        editHandler={access.updateAccess && !rowData.isTriggered ? () => {
                          const rowDateTime = new Date(rowData?.dateTime);
                          const currentDate = new Date();
                          if (rowDateTime < currentDate) {
                            toast.error("Notification already sent.");
                          }
                          else {
                            this.showEditModal(rowData);
                          }
                        } : null}
                        deleteHandler={access.deleteAccess && !rowData.isTriggered ? () => {
                          const rowDateTime = new Date(rowData?.dateTime);
                          const currentDate = new Date();
                          if (rowDateTime < currentDate) {
                            toast.error("Notification already sent.");
                          }
                          else {
                            this.openCloseDeleteModal(rowData);
                        }
                        } : null}
                      />
                    );
                },
              },
            ]}
            total={listData?.length || 0}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllNotificationSetupApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NotificationSetup));
